import { Node_Type } from "./../../../../ricos-schema/legacy/wix/rich_content/v1/index.js";
import BlockquoteRenderer from "./blockquote/blockquote.js";
import CodeBlockRenderer from "./codeblock/codeblock.js";
import HeadingRenderer from "./heading/heading.js";
import { LayoutCellRenderer } from "./layout/cell.js";
import { LayoutRenderer } from "./layout/layout.js";
import BulletedListRenderer from "./lists/bulleted-list.js";
import ListItemRenderer from "./lists/list-item.js";
import OrderedListRenderer from "./lists/ordered-list.js";
import ParagraphRenderer from "./paragraph/paragraph.js";
import TextRenderer from "./text/text.js";
const renderers = {
  [Node_Type.PARAGRAPH]: ParagraphRenderer,
  [Node_Type.TEXT]: TextRenderer,
  [Node_Type.BLOCKQUOTE]: BlockquoteRenderer,
  [Node_Type.CODE_BLOCK]: CodeBlockRenderer,
  [Node_Type.HEADING]: HeadingRenderer,
  [Node_Type.BULLETED_LIST]: BulletedListRenderer,
  [Node_Type.ORDERED_LIST]: OrderedListRenderer,
  [Node_Type.LIST_ITEM]: ListItemRenderer,
  [Node_Type.LAYOUT]: LayoutRenderer,
  [Node_Type.LAYOUT_CELL]: LayoutCellRenderer
};
export {
  renderers
};
//# sourceMappingURL=index.js.map
